module.exports = __webpack_public_path__ + "static/media/fr.61406a35.svg";